export const SERVER_URL = 'https://web.singlebroker.com/'